export class AppConstants {
  public static readonly DefaultLanguage = 'en';
}

export class AppQueryParams {
  public static readonly EntityId = 'entityId';
  public static readonly WorkUnitId = 'workUnitId';
  public static readonly ProjectId = 'projectId';
}
